module.exports = __webpack_public_path__ + "img/coffe.20ee3746.svg";